import { render, staticRenderFns } from "./StrongPoint.vue?vue&type=template&id=1be11cbc&"
import script from "./StrongPoint.vue?vue&type=script&lang=ts&"
export * from "./StrongPoint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports